import { ISharedDiagnosticReport } from '../../types/diagnostics'
import GeneralInfosBox from './components/GeneralInfos'
import DiscussionBox from './components/DiscussionBox'
import AttachmentsBox from './components/AttachmentsBox'
import ContextBox from './components/ContextBox'
import Header from './components/Header'
import { Document, Page } from '@react-pdf/renderer'
import { styles } from './styles'
import AiReportBox from './components/AiReportBox'

const ReportToPrint = ({
  reportData,
  imageSources = {},
}: {
  reportData: ISharedDiagnosticReport
  imageSources?: Record<string, string>
}) => {
  const hasAnalysis = reportData.diagnosticImages?.some(
    (image) => image.analysisType !== null
  )

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header reportData={reportData} />
        <GeneralInfosBox reportData={reportData} />
        <ContextBox reportData={reportData} />
        <AttachmentsBox
          diagnosticImages={reportData.diagnosticImages}
          imageSources={imageSources}
        />
        <DiscussionBox
          diagnosticImages={reportData.diagnosticImages}
          imageSources={imageSources}
        />

        {hasAnalysis && (
          <AiReportBox diagnosticImages={reportData.diagnosticImages} />
        )}
      </Page>
    </Document>
  )
}

export default ReportToPrint
